/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FirefoxAmoInstallStatsFromJSON, FirefoxAmoInstallStatsToJSON } from './FirefoxAmoInstallStats';
/**
 * Check if a given object implements the InstallVisibilityResponse interface.
 */
export function instanceOfInstallVisibilityResponse(value) {
    if (!('chromeAndEdgeNote' in value) || value['chromeAndEdgeNote'] === undefined)
        return false;
    if (!('chromeAndEdgeOfficialSourceExists' in value) || value['chromeAndEdgeOfficialSourceExists'] === undefined)
        return false;
    if (!('firefoxAmo' in value) || value['firefoxAmo'] === undefined)
        return false;
    if (!('firefoxAmoUnavailableReason' in value) || value['firefoxAmoUnavailableReason'] === undefined)
        return false;
    if (!('queriedAt' in value) || value['queriedAt'] === undefined)
        return false;
    return true;
}
export function InstallVisibilityResponseFromJSON(json) {
    return InstallVisibilityResponseFromJSONTyped(json, false);
}
export function InstallVisibilityResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'chromeAndEdgeNote': json['chromeAndEdgeNote'],
        'chromeAndEdgeOfficialSourceExists': json['chromeAndEdgeOfficialSourceExists'],
        'firefoxAmo': FirefoxAmoInstallStatsFromJSON(json['firefoxAmo']),
        'firefoxAmoUnavailableReason': json['firefoxAmoUnavailableReason'],
        'queriedAt': json['queriedAt'],
    };
}
export function InstallVisibilityResponseToJSON(json) {
    return InstallVisibilityResponseToJSONTyped(json, false);
}
export function InstallVisibilityResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'chromeAndEdgeNote': value['chromeAndEdgeNote'],
        'chromeAndEdgeOfficialSourceExists': value['chromeAndEdgeOfficialSourceExists'],
        'firefoxAmo': FirefoxAmoInstallStatsToJSON(value['firefoxAmo']),
        'firefoxAmoUnavailableReason': value['firefoxAmoUnavailableReason'],
        'queriedAt': value['queriedAt'],
    };
}
